import useSWR from 'swr'

import {
  recipeFetcher as menuExperienceRecipeFetcher,
  type RecipeQueryResponse,
} from '@library/api-menu-experience'

export const useFetchRecipeExperience = (
  menuId: string,
  recipeUuid: string | null,
  numPortions: number,
  deliveryDate: string,
  shouldFetchOptions = true,
  collectionId?: string,
): {
  error: boolean
  loading: boolean
  recipe: RecipeQueryResponse | null
  reload: () => void
} => {
  const { data, mutate, isValidating, error } = useSWR(
    () =>
      recipeUuid && shouldFetchOptions
        ? {
            menuId,
            recipeId: recipeUuid,
            numPortions,
            deliveryDate,
            collectionId,
          }
        : null,
    menuExperienceRecipeFetcher,
  )

  const reload = () => {
    mutate()
  }

  return {
    error: !!error,
    loading: !data && isValidating,
    recipe: data || null,
    reload,
  }
}
